/**
 * Growth Hub 首页（/app/growthhub）。菜单 Growth hub。
 * 打开页面打 STATSIG.COMMON.VIEW，value=growth_hub。
 * 点卡片并真正跳转打 ITEM_CLICK。
 * 免费套餐点 Open house finder 弹出升级打 UPGRADE_BLOCK，弹窗点 Upgrade 打 UPGRADE。
 * 已不算：关升级弹窗、View plan details、已注释的 Bluerate 卡片。
 * Personal site 编辑页、Finder 页内操作不跨到这里。
 */
export enum GrowthHubOverviewEvent {
    /**
     * 点一张卡片并跳转。
     * value 与 metadata.item 相同：personal_site_bluerate|open_house_finder
     */
    ITEM_CLICK = 'GROWTH_HUB_ITEM_CLICK',
    /**
     * 免费套餐点 Open house finder，弹出升级。
     * value 与 metadata.item 相同：open_house_finder
     */
    UPGRADE_BLOCK = 'GROWTH_HUB_UPGRADE_BLOCK',
    /**
     * 升级弹窗点 Upgrade。
     * value 与 metadata.plan 相同：individual
     */
    UPGRADE = 'GROWTH_HUB_UPGRADE',
}
